export const PATHS = {
  PAGE_404: "*",
  ROOT: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_VERIFY: "/forgot-password/verify",
  FORGOT_PASSWORD_NEW_PASSWORD: "/forgot-password/new-password",
  QUICK_LOGIN: "/quick-login",
  ROLES: "/roles",

  /** Shared profile (all roles) */
  PROFILE_BASIC_DETAILS: "/profile/basic-details",
  PROFILE_REPORT_ISSUE: "/profile/report-issue",

  // Receptionist

  RECEPTIONIST_DASHBOARD: "/receptionist/dashboard",
  RECEPTIONIST_APPOINTMENTS: "/receptionist/appointments",
  RECEPTIONIST_COMPLETE_OPD_PAYMENT:
    "/receptionist/appointments/complete-payment",
  RECEPTIONIST_APPOINTMENTS_CALENDAR: "/receptionist/appointments/calendar",
  RECEPTIONIST_PATIENTS: "/receptionist/patients",
  ADD_RECEPTIONIST_APPOINTMENT: "/receptionist/appointments/add",
  RECEPTIONIST_BILLINGS: "/receptionist/billings",
  RECEPTIONIST_VIEW_INVOICE: "/receptionist/billings/:invoiceId/view",
  RECEPTIONIST_DOCTOR_STATUS: "/receptionist/doctor-status",
  VIEW_RECEPTIONIST_PATIENT: "/receptionist/patients/view",

  // Pre OPD Assessments

  PRE_OPD_ASSESSMENTS: "/pre-opd/assessments",
  PRE_OPD_ASSESSMENTS_ADD: "/pre-opd/assessments/add",
  PRE_OPD_ASSESSMENTS_EDIT: "/pre-opd/assessments/edit",
  PRE_OPD_ASSESSMENTS_VIEW: "/pre-opd/assessments/view",

  // Follow Up

  FOLLOW_UP_LIST: "/follow-up/list",

  // Doctor

  DOCTOR_DASHBOARD: "/doctor/dashboard",
  DOCTOR_APPOINTMENTS: "/doctor/appointments",
  VIEW_DOCTOR_APPOINTMENT: "/doctor/appointments/view",
  DOCTOR_PRESCRIPTIONS: "/doctor/prescriptions",
  VIEW_DOCTOR_PRESCRIPTION: "/doctor/prescriptions/view",
  ADD_DOCTOR_OPD_PRESCRIPTION: "/doctor/prescriptions/add/opd",
  OPD_PRESCRIPTION_SUMMARY: "/doctor/prescriptions/add/opd/summary",
  ADD_DOCTOR_IPD_PRESCRIPTION: "/doctor/prescriptions/add/ipd",
  IPD_PRESCRIPTION_SUMMARY: "/doctor/prescriptions/add/ipd/summary",
  EDIT_DOCTOR_OPD_PRESCRIPTION: "/doctor/prescriptions/edit/opd",
  OPD_PRESCRIPTION_EDIT_SUMMARY: "/doctor/prescriptions/edit/opd/summary",
  EDIT_DOCTOR_IPD_PRESCRIPTION: "/doctor/prescriptions/edit/ipd",
  IPD_PRESCRIPTION_EDIT_SUMMARY: "/doctor/prescriptions/edit/ipd/summary",
  DOCTOR_AI_PRESCRIPTION_REVIEWS: "/doctor/ai-prescription-reviews",
  VIEW_DOCTOR_AI_PRESCRIPTION: "/doctor/ai-prescription-reviews/view",
  EDIT_DOCTOR_AI_PRESCRIPTION: "/doctor/ai-prescription-reviews/edit",
  DOCTOR_AVATAR_CONVERSATIONS: "/doctor/avatar-conversations",
  VIEW_DOCTOR_AVATAR_CONVERSATION:
    "/doctor/avatar-conversations/:conversationId",
  VIEW_DHP: "/doctor/dhp/view",
  DOCTOR_FINANCES: "/doctor/finances",
  DOCTOR_PATIENTS: "/doctor/patients",
  VIEW_DOCTOR_PATIENT: "/doctor/patients/view",

  // Counsellor

  COUNSELLOR_DASHBOARD: "/counsellor/dashboard",
  COUNSELLOR_OPD_PATIENTS: "/counsellor/opd-patients",
  COUNSELLOR_OPD_VIEW: "/counsellor/opd-patients/view",
  COUNSELLOR_IPD_VIEW: "/counsellor/ipd-patients/view",
  COUNSELLOR_ITEM_INFO: "/counsellor/item-info",
  COUNSELLOR_INVOICES: "/counsellor/invoices",
  COUNSELLOR_TAKE_PAYMENT: "/counsellor/invoices/:invoiceId/take-payment",
  COUNSELLOR_PAYMENT_CONFIRM: "/counsellor/invoices/:invoiceId/payment",
  COUNSELLOR_VIEW_INVOICE: "/counsellor/invoices/:invoiceId/view",
  COUNSELLOR_PRINT_INVOICE: "/counsellor/invoices/:invoiceId/print",
  COUNSELLOR_CREATE_INVOICE: "/counsellor/create-invoice",

  // Nurse

  NURSE_DASHBOARD: "/nurse/dashboard",
  NURSE_IPD_PATIENTS: "/nurse/ipd-patients",
  NURSE_IPD_PATIENTS_VIEW: "/nurse/ipd-patients/view",

  // IPD

  IPD_DASHBOARD: "/ipd/dashboard",
  IPD_TRANSFERS: "/ipd/transfers",
  ADMIT_IPD_PATIENT: "/ipd/admit-patient",
  VIEW_IPD_PRESCRIPTION: "/ipd/prescriptions/view",
  IPD_TEMPLATES: "/ipd/templates",
  IPD_ROOMS: "/ipd/rooms",
  VIEW_IPD_ROOM: "/ipd/rooms/view",
  IPD_USERS: "/ipd/users",
  VIEW_IPD_USER: "/ipd/users/view",
  DISCHARGE_IPD_USER: "/ipd/users/discharge",
  IPD_PROCEDURES: "/ipd/procedures",
  ADD_IPD_PROCEDURE: "/ipd/procedures/add",
  VIEW_IPD_PROCEDURE: "/ipd/procedures/view",
  EDIT_IPD_PROCEDURE: "/ipd/procedures/edit",
  IPD_KNOWLEDGE: "/ipd/knowledge",
  VIEW_IPD_KNOWLEDGE: "/ipd/knowledge/view",
  IPD_BILLINGS: "/ipd/billings",
  GENERATE_IPD_BILLING: "/ipd/billings/generate",
  IPD_INVENTORY: "/ipd/inventory",
  IPD_INVENTORY_REQUESTS: "/ipd/inventory/requests",

  // Radiologist
  RADIOLOGIST_DASHBOARD: "/radiologist/dashboard",
  RADIOLOGIST_BOOKINGS: "/radiologist/bookings",
  VIEW_RADIOLOGIST_BOOKING: "/radiologist/bookings/view",

  // Lab Test
  LAB_TEST_DASHBOARD: "/lab-test/dashboard",
  LAB_TEST_BOOKINGS: "/lab-test/bookings",
  VIEW_LAB_TEST_BOOKING: "/lab-test/bookings/view",
  LAB_TEST_PICKUPS: "/lab-test/pickups",

  // Pharmacist
  PHARMACIST_DASHBOARD: "/pharmacist/dashboard",
  PHARMACIST_PATIENTS: "/pharmacist/patients",
  PHARMACIST_VIEW_PATIENT_INVOICE:
    "/pharmacist/patients/invoice/:invoiceId/view",
  PHARMACIST_OTC_INVOICES: "/pharmacist/otc-invoices",
  PHARMACIST_OTC_VIEW_INVOICE: "/pharmacist/otc-invoices/:invoiceId/view",
  PHARMACIST_CREATE_OTC_INVOICE: "/pharmacist/otc-invoices/create",
  PHARMACIST_CREATE_PATIENT_INVOICE: "/pharmacist/patients/:ipdCaseId/invoice",
  PHARMACIST_INVENTORY: "/pharmacist/inventory",
  PHARMACIST_INVENTORY_VIEW: "/pharmacist/inventory/view",
  PHARMACIST_INVENTORY_BULK_UPDATE: "/pharmacist/inventory/bulk-update",
  PHARMACIST_ORDERS: "/pharmacist/orders",
  PHARMACIST_ORDERS_VIEW: "/pharmacist/orders/:orderId/view",

  // Therapist
  THERAPIST_DASHBOARD: "/therapist/dashboard",
  THERAPIST_APPOINTMENTS: "/therapist/appointments",
  THERAPIST_APPOINTMENT_VIEW: "/therapist/appointments/:opdId",
  THERAPIST_APPOINTMENT_PRESCRIPTION:
    "/therapist/appointments/:opdId/prescription/:prescriptionId",
  THERAPIST_APPOINTMENT_DHP: "/therapist/appointments/:opdId/dhp",
  THERAPIST_APPOINTMENT_ADD_THERAPY:
    "/therapist/appointments/:opdId/add-therapy",
  THERAPIST_IN_PATIENT_DEPT: "/therapist/in-patient-dept",
  THERAPIST_IN_PATIENT_DEPT_VIEW: "/therapist/in-patient-dept/:ipdCaseId",
  THERAPIST_IN_PATIENT_DEPT_DHP: "/therapist/in-patient-dept/:ipdCaseId/dhp",
  THERAPIST_IN_PATIENT_DEPT_ADD_THERAPY:
    "/therapist/in-patient-dept/:ipdCaseId/add-therapy",
  THERAPIST_INVENTORY: "/therapist/inventory",
  THERAPIST_INVENTORY_REQUESTS: "/therapist/inventory/requests",

  // Yoga
  YOGA_DASHBOARD: "/yoga/dashboard",
  YOGA_BUSINESS_DASHBOARD: "/staff/yoga-business/dashboard",
  YOGA_APPOINTMENTS: "/yoga/appointments",
  VIEW_YOGA_APPOINTMENT: "/yoga/appointments/view",
  YOGA_APPOINTMENT_PRESCRIPTION: "/yoga/appointments/prescription",
  YOGA_APPOINTMENT_DHP: "/yoga/appointments/dhp",
  YOGA_IN_PATIENT_DEPT: "/yoga/in-patient-dept",
  VIEW_YOGA_IN_PATIENT_DEPT: "/yoga/in-patient-dept/view",
  YOGA_IN_PATIENT_DEPT_DHP: "/yoga/in-patient-dept/dhp",
  YOGA_PAYMENT_INVOICES: "/yoga/payment-invoices",
  YOGA_VIEW_PAYMENT_INVOICE: "/yoga/payment-invoices/:invoiceId",
  YOGA_PRINT_PAYMENT_INVOICE: "/yoga/payment-invoices/:invoiceId/print",
  YOGA_FINANCES: "/yoga/finances",
  YOGA_SESSIONS: "/yoga/sessions",
  VIEW_YOGA_SESSION_GROUP: "/yoga/sessions/view/group",
  VIEW_YOGA_SESSION_ONE_ON_ONE: "/yoga/sessions/view/one-on-one",
  VIEW_YOGA_SESSION_RECORDED: "/yoga/sessions/view/recorded",
  YOGA_SESSION_GROUP_FORM: "/yoga/sessions/group",
  YOGA_SESSION_RECORDED_FORM: "/yoga/sessions/recorded",
  YOGA_SESSION_ONE_ON_ONE_FORM: "/yoga/sessions/one-on-one",
  YOGA_SESSION_GROUP_EDIT_FORM: "/yoga/sessions/group/edit",
  YOGA_SESSION_RECORDED_EDIT_FORM: "/yoga/sessions/recorded/edit",
  YOGA_SESSION_ONE_ON_ONE_EDIT_FORM: "/yoga/sessions/one-on-one/edit",

  // Billing Manager
  BILLING_MANAGER_DASHBOARD: "/billing-manager/dashboard",
  BILLING_MANAGER_PROVIDERS: "/billing-manager/providers",
  VIEW_BILLING_MANAGER_PROVIDER: "/billing-manager/providers/view",
  VIEW_BILLING_MANAGER_PROVIDER_INVOICE: "/billing-manager/providers/invoice",
  BILLING_MANAGER_INVOICES: "/billing-manager/invoices",
  VIEW_BILLING_MANAGER_INVOICE: "/billing-manager/invoices/view",
  BILLING_MANAGER_REFUNDS: "/billing-manager/refunds",
  VIEW_BILLING_MANAGER_REFUND: "/billing-manager/refunds/view",
  PAYMENT_BILLING_MANAGER_INVOICE: "/billing-manager/invoices/payment",

  // Staff Manager
  STAFF_MANAGER_STAFF: "/staff-manager/staff",
  STAFF_MANAGER_STAFF_VIEW: "/staff-manager/staff/view",
  STAFF_MANAGER_ADD_STAFF: "/staff-manager/staff/add",
  STAFF_MANAGER_EDIT_STAFF: "/staff-manager/staff/edit",
  STAFF_MANAGER_ADD_SLOTS: "/staff-manager/staff/add-slots",
  STAFF_MANAGER_EDIT_SLOTS: "/staff-manager/staff/edit-slots",

  // Dietician
  DIETICIAN_DASHBOARD: "/dietician/dashboard",
  DIETICIAN_APPOINTMENTS: "/dietician/appointments",
  VIEW_DIETICIAN_APPOINTMENT: "/dietician/appointments/view",
  ADD_DIETICIAN_PRESCRIPTION: "/dietician/prescription/add",
  VIEW_DIETICIAN_PRESCRIPTION: "/dietician/prescription/view",
  DIETICIAN_PLANS: "/dietician/plans",
  VIEW_DIETICIAN_PLAN: "/dietician/plans/view",
  ADD_DIETICIAN_PLAN: "/dietician/plans/add",
  EDIT_DIETICIAN_PLAN: "/dietician/plans/edit",
  DIETICIAN_IPDS: "/dietician/ipds",
  DIETICIAN_IPD_VIEW: "/dietician/ipds/view",
  DIETICIAN_IPD_DHP: "/dietician/ipds/view/dhp",
  DIETICIAN_APPOINTMENT_DHP: "/dietician/appointments/dhp",

  // Store Manager
  STORE_MANAGER_DASHBOARD: "/store-manager/dashboard",
  STORE_MANAGER_INVENTORY: "/store-manager/inventory",
  STORE_MANAGER_INVENTORY_BULK_UPDATE: "/store-manager/inventory/bulk-update",
  VIEW_STORE_MANAGER_INVENTORY: "/store-manager/inventory/view",
  STORE_MANAGER_ASSIGNMENT_HISTORY: "/store-manager/assignment-history",
  STORE_MANAGER_REQUESTS: "/store-manager/requests",
  VIEW_STORE_MANAGER_REQUEST: "/store-manager/requests/view",
  STORE_MANAGER_PRODUCTS: "/store-manager/products",
  VIEW_STORE_MANAGER_PRODUCT: "/store-manager/products/view",
  ADD_STORE_MANAGER_PRODUCT: "/store-manager/products/add",
  EDIT_STORE_MANAGER_PRODUCT: "/store-manager/products/edit",
  ADD_STORE_MANAGER_BULK_PRODUCT: "/store-manager/products/add-bulk",
  STORE_MANAGER_SERVICES: "/store-manager/services",
  VIEW_STORE_MANAGER_SERVICE: "/store-manager/services/view",
  ADD_STORE_MANAGER_SERVICE: "/store-manager/services/add",
  EDIT_STORE_MANAGER_SERVICE: "/store-manager/services/edit",
  ADD_STORE_MANAGER_BULK_SERVICE: "/store-manager/services/add-bulk",

  // Logistics
  LOGISTICS: "/logistics",
  LOGISTICS_MANIFESTS: "/logistics/manifests",

  // Admin
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_STAKEHOLDERS: "/admin/stakeholders",
  ADMIN_MINUTES_WALLET: "/admin/minutes-wallet",
  ADMIN_COIN_MANAGEMENT: "/admin/coin-management",
  ADMIN_COIN_MANAGEMENT_VIEW: "/admin/coin-management/:staffId",
};
